import React from 'react';
import Navbar from './layout/Navbar';
import Footer from './layout/Fotter';
import { Link } from 'react-router-dom';

// Factory and company images (replace with your actual images)
import factoryImage1 from '../assets/image21.webp';
import factoryImage2 from '../assets/image25.jpg';
import factoryImage3 from '../assets/image27.jpg';
import aboutHeroImage from '../assets/image28.jpg';
import image35 from '../assets/image35.avif';
import teamImage from '../assets/image32.jpg';
import { Award, Eye, Factory, Grid, MapIcon, Rocket, Star, User } from 'lucide-react';

const About = () => {
  // Function to prevent right-click and dragging
  const preventDefault = (e) => {
    e.preventDefault();
  };

  const milestones = [
    {
      year: "2010",
      title: "Foundation",
      description: "GMC Ceramic established with a vision to revolutionize the ceramic industry",
    },
    {
      year: "2015",
      title: "Expansion",
      description: "Expanded production capacity and introduced new product lines",
    },
    {
      year: "2018",
      title: "ISO Certification",
      description: "Achieved ISO 9001:2015 certification for quality management",
    },
    {
      year: "2020",
      title: "Technology Upgrade",
      description: "Invested in cutting-edge Italian machinery for precision manufacturing",
    },
    {
      year: "2023",
      title: "Market Leadership",
      description: "Became one of the leading ceramic manufacturers in the region",
    },
  ];

  const factoryProcess = [
    {
      step: "01",
      title: "Raw Material Selection",
      description: "Premium quality clay and minerals sourced from certified suppliers",
      image: factoryImage1,
    },
    {
      step: "02",
      title: "Precision Manufacturing",
      description: "State-of-the-art Italian machinery ensures consistent quality and finish",
      image: factoryImage2,
    },
    {
      step: "03",
      title: "Quality Control",
      description: "Rigorous testing at every stage to maintain international standards",
      image: factoryImage3,
    },
  ];

  const stats = [
    { number: "50,000+", label: "Sq. Ft. Factory Space", icon:<Factory className='mx-auto h-7 w-7 sm:h-10 sm:w-10 text-white' /> },
    { number: "100+", label: "Skilled Workers", icon:<User className='mx-auto h-7 w-7 sm:h-10 sm:w-10 text-white' /> },
    { number: "1000+", label: "Tiles Per Day", icon:<Grid className='mx-auto h-7 w-7 sm:h-10 sm:w-10 text-white' /> },
    { number: "50+", label: "Cities Served", icon:<MapIcon className='mx-auto h-7 w-7 sm:h-10 sm:w-10 text-white' /> },
  ];

  return (
    <div className="w-full overflow-hidden select-none" onContextMenu={preventDefault}>
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[50vh] sm:h-[60vh] md:h-[70vh] lg:h-[80vh] bg-gradient-to-r from-gray-900 to-gray-700 select-none">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat select-none"
          style={{
            backgroundImage: `url(${aboutHeroImage})`,
            backgroundBlendMode: 'overlay',
            userSelect: 'none',
            WebkitUserSelect: 'none',
            MozUserSelect: 'none',
          }}
          onContextMenu={preventDefault}
          onDragStart={preventDefault}
        ></div>
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="absolute inset-0 z-10" onContextMenu={preventDefault}></div>
        <div className="relative z-20 h-full flex items-center justify-center select-none">
          <div className="text-center text-white max-w-full sm:max-w-2xl md:max-w-3xl lg:max-w-4xl px-4 sm:px-6 select-none">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-orange-500 mb-4 sm:mb-6 select-none">
              About GMC Ceramic
            </h1>
            <p className="text-base sm:text-lg md:text-xl lg:text-2xl font-light leading-relaxed select-none">
              Crafting Excellence in Ceramic Manufacturing Since 2010
            </p>
            <div className="mt-4 sm:mt-6 lg:mt-8 select-none">
              <div className="w-16 sm:w-20 lg:w-24 h-1 bg-orange-500 mx-auto"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Company Story Section */}
      <section className="py-8 sm:py-12 lg:py-16 bg-white select-none">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-12 items-center">
            <div className="select-none">
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4 sm:mb-6 select-none">
                Our <span className="text-orange-600">Journey</span>
              </h2>
              <p className="text-sm sm:text-base md:text-lg text-gray-600 mb-4 sm:mb-6 leading-relaxed select-none">
                GMC Ceramic began as a vision to transform the ceramic industry with innovative designs
                and uncompromising quality. What started as a small manufacturing unit has grown into
                one of the region's most trusted ceramic brands.
              </p>
              <p className="text-sm sm:text-base md:text-lg text-gray-600 mb-4 sm:mb-6 leading-relaxed select-none">
                Our commitment to excellence, continuous innovation, and customer satisfaction has
                driven us to invest in state-of-the-art technology and skilled craftsmanship, making
                us a preferred choice for architects, designers, and homeowners alike.
              </p>
              <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 select-none">
                <div className="bg-orange-100 p-4 sm:p-6 rounded-lg text-center select-none">
                  <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-orange-600 select-none">13+</h3>
                  <p className="text-sm sm:text-base text-gray-700 select-none">Years of Excellence</p>
                </div>
                <div className="bg-orange-100 p-4 sm:p-6 rounded-lg text-center select-none">
                  <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-orange-600 select-none">5000+</h3>
                  <p className="text-sm sm:text-base text-gray-700 select-none">Projects Completed</p>
                </div>
              </div>
            </div>
            <div className="relative select-none">
              <img
                src={teamImage}
                alt="GMC Ceramic Team"
                className="rounded-lg shadow-2xl w-full h-48 sm:h-56 md:h-64 lg:h-80 object-cover select-none"
                onContextMenu={preventDefault}
                onDragStart={preventDefault}
                style={{ userSelect: 'none', WebkitUserSelect: 'none', MozUserSelect: 'none' }}
              />
              <div className="absolute inset-0 z-10" onContextMenu={preventDefault}></div>
              <div className="absolute -bottom-4 sm:-bottom-6 -right-4 sm:-right-6 bg-orange-600 text-white p-3 sm:p-4 lg:p-6 rounded-lg shadow-lg select-none">
                <h4 className="text-sm sm:text-base md:text-lg lg:text-xl font-bold select-none">Quality First</h4>
                <p className="text-xs sm:text-sm select-none">Always</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Manufacturing Process Section */}
      <section className="py-8 sm:py-12 lg:py-16 bg-gray-50 select-none">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12 lg:mb-16 select-none">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-3 sm:mb-4 select-none">
              Our <span className="text-orange-600">Manufacturing Process</span>
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-2xl sm:max-w-3xl mx-auto select-none">
              From raw materials to finished tiles, every step is carefully monitored to ensure
              the highest quality standards
            </p>
          </div>

          {factoryProcess.map((process, index) => (
            <div key={index} className="mb-8 sm:mb-12 lg:mb-16 select-none">
              <div
                className={`grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-12 items-center ${index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''
                  }`}
              >
                {/* Content */}
                <div className={`${index % 2 === 1 ? 'lg:col-start-2' : ''} select-none`}>
                  <div className="flex items-center mb-4 sm:mb-6 select-none">
                    <div className="bg-orange-600 text-white text-lg sm:text-xl md:text-2xl font-bold w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center mr-3 sm:mr-4 select-none">
                      {process.step}
                    </div>
                    <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 select-none">{process.title}</h3>
                  </div>
                  <p className="text-sm sm:text-base md:text-lg text-gray-600 leading-relaxed mb-4 sm:mb-6 select-none">
                    {process.description}
                  </p>
                  <div className="bg-orange-100 p-4 sm:p-6 rounded-lg select-none">
                    <h4 className="font-bold text-orange-800 text-sm sm:text-base mb-2 select-none">Key Features:</h4>
                    <ul className="text-orange-700 text-xs sm:text-sm space-y-1 select-none">
                      {index === 0 && (
                        <>
                          <li className="select-none">• Premium clay from select quarries</li>
                          <li className="select-none">• Rigorous material testing</li>
                          <li className="select-none">• Consistent chemical composition</li>
                        </>
                      )}
                      {index === 1 && (
                        <>
                          <li className="select-none">• Italian Sacmi press machines</li>
                          <li className="select-none">• Automated production line</li>
                          <li className="select-none">• Precision temperature control</li>
                        </>
                      )}
                      {index === 2 && (
                        <>
                          <li className="select-none">• Multi-stage quality checks</li>
                          <li className="select-none">• Water absorption testing</li>
                          <li className="select-none">• Dimensional accuracy verification</li>
                        </>
                      )}
                    </ul>
                  </div>
                </div>

                {/* Image */}
                <div className={`${index % 2 === 1 ? 'lg:col-start-1' : ''} select-none`}>
                  <div className="relative">
                    <img
                      src={process.image}
                      alt={process.title}
                      className="rounded-lg shadow-2xl w-full h-48 sm:h-56 md:h-64 lg:h-72 object-cover select-none"
                      onContextMenu={preventDefault}
                      onDragStart={preventDefault}
                      style={{ userSelect: 'none', WebkitUserSelect: 'none', MozUserSelect: 'none' }}
                    />
                    <div className="absolute inset-0 z-10" onContextMenu={preventDefault}></div>
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-lg"></div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Factory Stats Section */}
      <section className="py-8 sm:py-12 lg:py-16 bg-orange-600 select-none">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12 select-none">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3 sm:mb-4 select-none">
              Our Manufacturing Capabilities
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-orange-100 max-w-2xl mx-auto select-none">
              State-of-the-art facilities equipped with modern technology
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8 select-none">
            {stats.map((stat, index) => (
              <div
                key={index}
                className="text-center bg-white bg-opacity-10 rounded-lg p-4 sm:p-6 backdrop-blur-sm hover:scale-105 transform transition-all duration-300 select-none"
              >
                <div className="text-2xl sm:text-3xl md:text-4xl mb-3 sm:mb-4 select-none">{stat.icon}</div>
                <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-2 select-none">{stat.number}</h3>
                <p className="text-sm sm:text-base text-orange-100 select-none">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Technology & Quality Section */}
      <section className="py-8 sm:py-12 lg:py-16 bg-white select-none">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-12">
            {/* Technology */}
            <div className="select-none">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 mb-4 sm:mb-6 select-none">
                <span className="text-orange-600">Advanced</span> Technology
              </h2>
              <div className="space-y-4 sm:space-y-6 select-none">
                {[
                  {
                    icon: "🔧",
                    title: "Italian Machinery",
                    desc: "State-of-the-art Sacmi and System equipment for precision manufacturing",
                  },
                  {
                    icon: "🌡️",
                    title: "Controlled Environment",
                    desc: "Temperature and humidity controlled production for consistent quality",
                  },
                  {
                    icon: "⚡",
                    title: "Automated Systems",
                    desc: "Fully automated production line reducing human error and improving efficiency",
                  },
                ].map((item, index) => (
                  <div key={index} className="flex items-start select-none">
                    <div className="bg-orange-100 p-2 sm:p-3 rounded-full mr-3 sm:mr-4 flex-shrink-0 select-none">
                      <span className="text-orange-600 font-bold text-sm sm:text-base select-none">{item.icon}</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-800 text-sm sm:text-base md:text-lg mb-1 sm:mb-2 select-none">{item.title}</h3>
                      <p className="text-gray-600 text-xs sm:text-sm md:text-base select-none">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Quality */}
            <div className="select-none">
              <div className="relative">
                <img
                  src={image35}
                  alt="Manufacturing Technology"
                  className="rounded-lg shadow-lg w-full h-48 sm:h-56 md:h-64 lg:h-80 object-cover mb-4 sm:mb-6 select-none"
                  onContextMenu={preventDefault}
                  onDragStart={preventDefault}
                  style={{ userSelect: 'none', WebkitUserSelect: 'none', MozUserSelect: 'none' }}
                />
                <div className="absolute inset-0 z-10" onContextMenu={preventDefault}></div>
              </div>
              <div className="bg-gray-50 p-4 sm:p-6 rounded-lg select-none">
                <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-orange-600 mb-3 sm:mb-4 select-none">Quality Certifications</h3>
                <div className="grid grid-cols-2 gap-3 sm:gap-4 select-none">
                  {[
                    { title: "ISO 9001:2015", desc: "Quality Management" },
                    { title: "BIS Certified", desc: "Indian Standards" },
                    { title: "CE Marking", desc: "European Compliance" },
                    { title: "Green Building", desc: "Eco Certified" },
                  ].map((cert, index) => (
                    <div key={index} className="text-center p-3 sm:p-4 bg-white rounded-lg shadow select-none">
                      <h4 className="font-bold text-gray-800 text-sm sm:text-base select-none">{cert.title}</h4>
                      <p className="text-xs sm:text-sm text-gray-600 select-none">{cert.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Company Timeline */}
      <section className="py-8 sm:py-12 lg:py-16 bg-gray-900 text-white select-none">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12 lg:mb-16 select-none">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4 select-none">
              Our <span className="text-orange-500">Milestones</span>
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-300 max-w-2xl mx-auto select-none">
              Key achievements that shaped our journey
            </p>
          </div>
          <div className="relative select-none">
            {/* Timeline Line */}
            <div className="absolute left-1/2 transform -translate-x-px h-full w-0.5 bg-orange-500 sm:block hidden"></div>
            {milestones.map((milestone, index) => (
              <div
                key={index}
                className={`relative flex flex-col sm:flex-row ${index % 2 === 0 ? 'sm:justify-start' : 'sm:justify-end'
                  } mb-8 sm:mb-12 select-none`}
              >
                {/* Timeline Dot */}
                <div className="absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-orange-500 rounded-full border-4 border-gray-900 sm:block hidden"></div>
                {/* Content Card */}
                <div
                  className={`w-full sm:w-5/12 ${index % 2 === 0 ? 'sm:pr-8' : 'sm:pl-8'} select-none`}
                >
                  <div className="bg-white text-gray-800 p-4 sm:p-6 rounded-lg shadow-lg select-none">
                    <div className="text-lg sm:text-xl md:text-2xl font-bold text-orange-600 mb-2 select-none">{milestone.year}</div>
                    <h3 className="text-base sm:text-lg md:text-xl font-bold mb-2 sm:mb-3 select-none">{milestone.title}</h3>
                    <p className="text-sm sm:text-base text-gray-600 select-none">{milestone.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Vision & Mission */}
      <section className="py-8 sm:py-12 lg:py-16 bg-gradient-to-r from-orange-50 to-orange-100 select-none">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 lg:gap-12 select-none">
            {/* Vision */}
            <div className="bg-white p-4 sm:p-6 lg:p-8 rounded-xl shadow-lg select-none">
              <div className="bg-orange-100 w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 rounded-full flex items-center justify-center mb-4 sm:mb-6 select-none">
                <span className="text-orange-600 text-lg sm:text-xl lg:text-2xl select-none"><Star className='mx-auto h-7 w-7 sm:h-10 sm:w-10' /></span>
              </div>
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 mb-3 sm:mb-4 select-none">Our Vision</h2>
              <p className="text-sm sm:text-base md:text-lg text-gray-600 leading-relaxed select-none">
                To be the most trusted and innovative ceramic manufacturer, setting new standards
                in quality, design, and sustainability while transforming spaces worldwide.
              </p>
            </div>

            {/* Mission */}
            <div className="bg-white p-4 sm:p-6 lg:p-8 rounded-xl shadow-lg select-none">
              <div className="bg-orange-100 w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 rounded-full flex items-center justify-center mb-4 sm:mb-6 select-none">
                <span className="text-orange-600 text-lg sm:text-xl lg:text-2xl select-none"><Rocket className='mx-auto h-7 w-7 sm:h-10 sm:w-10' /></span>
              </div>
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 mb-3 sm:mb-4 select-none">Our Mission</h2>
              <p className="text-sm sm:text-base md:text-lg text-gray-600 leading-relaxed select-none">
                To deliver exceptional ceramic solutions through continuous innovation, advanced
                technology, and unwavering commitment to quality that exceeds customer expectations.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-8 sm:py-12 lg:py-16 bg-gray-800 text-white select-none">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6 select-none">
            Ready to Experience <span className="text-orange-500">GMC Quality?</span>
          </h2>
          <p className="text-base sm:text-lg md:text-xl mb-4 sm:mb-6 lg:mb-8 max-w-2xl mx-auto select-none">
            Visit our factory or showroom to see our manufacturing process and product range firsthand
          </p>
          <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 justify-center select-none">
            <Link to="/contact">
              <button className="bg-orange-600 hover:bg-orange-700 text-white px-4 sm:px-6 lg:px-8 py-2 sm:py-3 lg:py-4 rounded-lg text-sm sm:text-base lg:text-lg font-semibold transition-all duration-300 transform hover:scale-105 select-none">
                Schedule Factory Visit
              </button>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;